'use strict';

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _err = require('./err');

var _err2 = _interopRequireDefault(_err);

var _common = require('./common');

var _common2 = _interopRequireDefault(_common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.mixin(_err2.default); /**
                                     * @file 插件
                                     */

_vue2.default.mixin(_common2.default);


//////////////////
// WEBPACK FOOTER
// ./src/mixins/index.js
// module id = 448
// module chunks = 14